import { useEffect, useRef } from 'react';
import { shoutoutLpPageView } from '@wix/bi-logger-wix-emails-data/v2';

import { useCampaign } from '../contexts';
import { panorama } from '../panorama';

import { useBiLogger } from './use-bi-logger';

export function useLpPageView() {
  const campaign = useCampaign();
  const logger = useBiLogger();
  const loadFinishReported = useRef(false);

  useEffect(() => {
    if (!loadFinishReported.current) {
      loadFinishReported.current = true;
      panorama.reportLoadFinish();
    }

    logger.report(
      shoutoutLpPageView({
        message_id: campaign.messageId,
      }),
    );
  }, [campaign.messageId, logger]);
}
